import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function FlashSaleBar() {
  const {
    formattedTime,
    minutes
  } = useCountdown(undefined, 900);
  const isUrgent = minutes < 5;
  const isCritical = minutes < 2;
  return <div className="bg-[#111827] text-white py-[5px] px-[10px] flex justify-center items-center sticky top-0 z-[1001] gap-[8px]" data-id="element-120">
      <span className="text-[11px] text-gray-400" data-id="element-121">⚡ Offer ends in</span>
      <div className={`text-[12px] font-[900] px-[10px] py-[3px] rounded-[4px] tracking-[1px] ${isCritical ? 'bg-[#EF4444] text-white animate-pulse' : isUrgent ? 'bg-[#F59E0B] text-[#111827]' : 'bg-[#FCA5A5] text-[#111827]'}`} style={{
      minWidth: '60px',
      textAlign: 'center',
      ...(isCritical ? {
        boxShadow: '0 0 12px rgba(239,68,68,0.6)'
      } : {})
    }} data-id="element-122">
        {formattedTime}
      </div>
    </div>;
}